import { Injectable } from '@angular/core';
import { PopoverController } from "ionic-angular";

/*
  Generated class for the WebToAppModalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class WebToAppPopoverProvider {

  constructor(
    public popoverCtrl: PopoverController
  ) {}
  checkTodayTime(): void {
    const getBlockTimeKey: string = "get-block-time";
    const today: string = "modal";
    let update = false;
    const blockTime = localStorage.getItem(getBlockTimeKey);
    if (blockTime) {
      if (Number(blockTime) >= Date.now()) {
        update = true;
        localStorage.setItem(today, "not show");
      }
    }
     if (!update) {
      const blockTime = this.getTomorrowBlockDateTime();
      localStorage.setItem(getBlockTimeKey, blockTime.toString());
      localStorage.setItem(today, "show");
    }
  }
   private getTomorrowBlockDateTime() {
    var t = new Date();
    t.setDate(t.getDate() + 1);
    const blockTime = new Date(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      5,
      0,
      0
    );
    return blockTime.getTime();
  }
}



// WEBPACK FOOTER //
// ./src/providers/popover/web-to-app-popover/web-to-app-popover.ts